import { render, staticRenderFns } from "./TopBarEditableTitle.vue?vue&type=template&id=55f7b2be&scoped=true"
import script from "./TopBarEditableTitle.vue?vue&type=script&lang=js"
export * from "./TopBarEditableTitle.vue?vue&type=script&lang=js"
import style0 from "./TopBarEditableTitle.vue?vue&type=style&index=0&id=55f7b2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f7b2be",
  null
  
)

export default component.exports